// import packageJson from '../../../package.json';
export const REACT_APP_API_HOSTNAME = `${process.env.REACT_APP_API_HOSTNAME_2026}`;
export const REACT_APP_API_HOSTNAME_NEW = `${process.env.REACT_APP_API_HOSTNAME_NEW_NEW2026}`; // `${process.env.REACT_APP_API_HOSTNAME_NEW}`;
export const API_URL_PATH = `${REACT_APP_API_HOSTNAME}/contact/v1`;
export const SMSAPI_URL_PATH = `${REACT_APP_API_HOSTNAME}/sms/v1`;
export const SMSAPI_GRPC_URL_PATH = `${REACT_APP_API_HOSTNAME}/sms_grpc/v1/sms/v1`;
export const UI_API_URL_PATH = `${REACT_APP_API_HOSTNAME}/reader/v1`;
export const UI_API_URL_PATH_NEW = `${REACT_APP_API_HOSTNAME_NEW}`;

// added new
// export const API_URL_PATH = 'https://api.edumarcsms.com/contact/v1';
// //adding new hash
export const SMART_URL = process.env.REACT_APP_SMART_URL;
export const GA_ID = process.env.REACT_APP_GA_ID;
export const GA_DEBUG = process.env.REACT_APP_DEBUG;

export const LOGIN = "LOGIN";
// export const LOGIN_URL = `${ API_URL_PATH }/api/auth/sign-in`;
export const LOGIN_URL = `${UI_API_URL_PATH_NEW}/api/v1/users/login`;

export const LOGOUT = "LOGOUT";
// export const LOGOUT_URL = `${ API_URL_PATH }/api/auth/sign-out`;
export const LOGOUT_URL = `${UI_API_URL_PATH_NEW}/api/v1/users/logout`;

export const GET_ALL_USER = "GET_ALL_USER";
export const SEARCH_CONTACTS = "SEARCH_CONTACTS";
// Tenants with more contacts than this skip the full in-memory load and
// drive the Sms picker via server-side trigram search instead.
export const CONTACT_CACHE_THRESHOLD = 10000;
// Go ContactService (grpc-gateway). Legacy: `${API_URL_PATH}/api/contact`
export const USER_URL = `${UI_API_URL_PATH_NEW}/api/v1/contacts`;
export const ADD_USER = "ADD_USER";
export const DELETE_USER = "DELETE_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DOWNLOAD_CONTACT = "DOWNLOAD_CONTACT";
// Streaming CSV export. Legacy: `${API_URL_PATH}/api/contact/sheet`
export const DOWNLOAD_CONTACT_URL = `${UI_API_URL_PATH_NEW}/api/v1/contacts:export`;
export const GET_CONTACT_GROUP = "GET_CONTACT_GROUP";
// Groups + counts for Send-SMS dropdown. Legacy: `${API_URL_PATH}/api/contact/contactGroup`
export const GET_CONTACT_GROUP_URL = `${UI_API_URL_PATH_NEW}/api/v1/contacts:group-summary`;

export const UPDATE_SMS_DETAILS = "UPDATE_SMS_DETAILS";
export const SEND_SMS = "SEND_SMS";
export const SEND_SMS_URL = `${REACT_APP_API_HOSTNAME_NEW}/api/v1/ui/sms/send`;
export const SEND_CUSTOM_SMS_URL = `${REACT_APP_API_HOSTNAME_NEW}/api/v1/ui/sms/send-custom`;
export const SEND_CUSTOM_SMS = "SEND_CUSTOM_SMS";

export const GET_SMS_HISTORY = "GET_SMS_HISTORY";
// export const GET_SMS_HISTORY_URL = `${ SMSAPI_URL_PATH }/api/smsHistory`;

export const GET_SMS_HISTORY_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/campaigns`;

export const GET_ALL_SMS_HISTORY = "GET_ALL_SMS_HISTORY";
// export const GET_ALL_SMS_HISTORY_URL = `${ SMSAPI_URL_PATH }/api/smstransaction`;
export const GET_ALL_SMS_HISTORY_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/messages`;
export const GET_TRACK_CAMPAIGN = "GET_TRACK_CAMPAIGN";
export const GET_TRACK_CAMPAIGN_DELIVERY = "GET_TRACK_CAMPAIGN";
export const GET_TRACK_CAMPAIGN_DELIVERY_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/campaigns/{campaign_id}/tracking`;
export const GET_MESSAGE_TEXT_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/campaigns/{campaign_id}/messages/{message_id}/text`;

// Go ContactService group endpoints (grpc-gateway). Legacy: `${API_URL_PATH}/api/group`
export const GROUP_URL = `${UI_API_URL_PATH_NEW}/api/v1/contact-groups`;
// Membership add/remove lives under /api/v1/contact-groups/{gId}/contacts (:remove suffix for DELETE)
export const GROUP_CONTACT_URL = `${UI_API_URL_PATH_NEW}/api/v1/contact-groups/gId/contacts`;
export const GROUP_CONTACT_REMOVE_URL = `${UI_API_URL_PATH_NEW}/api/v1/contact-groups/gId/contacts:remove`;
export const GROUP_DETAILS = "GROUP_DETAILS";
export const ADD_USER_GROUP = "ADD_USER_GROUP";
export const UPDATE_GROUP = "UPDATE_GROUP";
export const DELETE_USER_GROUP = "DELETE_USER_GROUP";
export const ADD_GROUP = "ADD_GROUP";
export const DELETE_GROUP = "DELETE_GROUP";
export const ALL_GROUP_DETAILS = "ALL_GROUP_DETAILS";
export const DOWNLOAD_GROUP_CONTACT = "DOWNLOAD_GROUP_CONTACT";
// Streaming per-group CSV export. Legacy: `${API_URL_PATH}/api/group/gId/sheet`
export const DOWNLOAD_GROUP_CONTACT_URL = `${UI_API_URL_PATH_NEW}/api/v1/contact-groups/gId:export`;

export const SMS_HISTORY_STATUS = "SMS_HISTORY_STATUS";
export const SMS_HISTORY_STATUS_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/campaigns/{campaign_id}/messages`;

export const SMS_HISTORY_SMART_STATUS = "SMS_HISTORY_SMART_STATUS";
export const SMS_HISTORY_SMART_STATUS_URL = `${SMSAPI_URL_PATH}/api/smsTransaction/url/tId`;

// export const SMS_HISTORY_DWNL_REPORT_URL = `${ SMSAPI_URL_PATH }/api/smsTransaction/sheet/generateUrl/tId`;
export const SMS_HISTORY_DWNL_REPORT_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/reports/campaigns/{campaign_id}/generate`;
export const SMS_HISTORY_DWNL_REPORT_JOB_STATUS_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/reports/jobs/{job_id}/status`;
export const SMS_HISTORY_DWNL_FILTER_REPORT_JOB_ID =
  "SMS_HISTORY_DWNL_FILTER_REPORT_JOB_ID";
export const SMS_HISTORY_DWNL_FILTER_REPORT_URL = `${API_URL_PATH}/api/sms/report?startDate=sDate&endDate=eDate`;
// export const SMS_HISTORY_DWNL_FULL_REPORT = `${ SMSAPI_URL_PATH }/api/smsTransaction/sheet/generateUrl/reports/`;
export const SMS_HISTORY_DWNL_FULL_REPORT = "SMS_HISTORY_DWNL_FULL_REPORT";
// Campaign-level summary report (one row per campaign with counts/totals).
// Kept available but the dashboard Download button now uses the detailed
// per-message endpoint below, which matches the legacy production report.
export const SMS_HISTORY_DWNL_FULL_REPORT_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/reports/campaigns/generate`;
// Per-message detailed report — one row per individual SMS across campaigns
// matching the filter (date range / sender / message type / phone /
// optional campaign_id). Legacy-shape CSV columns (Message ID, Mobile
// Number, Header, Delivery Status, Template ID, SMS Unit Count, Error
// Code, Error Description, Submitted Time, Delivery Status Time, Message)
// + IST DD-MM-YYYY hh:mm:ss AM/PM time format. Companion to the summary
// endpoint above; backed by combird_apps commit 54286916 +
// ui-service stage.209-messages-detailed-report.
export const SMS_HISTORY_DWNL_MESSAGES_DETAILED_REPORT_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/reports/campaigns/messages/detail/reports`;
export const GET_ALL_AGENT_DETAILS = "GET_ALL_AGENT_DETAILS";
export const AGENT_DETAILS_V2_URL = `${UI_API_URL_PATH_NEW}/api/v2/organizations`;
// The org LIST. v3 reads combird's own tables — no zitadel call — so it is
// paged, filtered and ordered server-side, and its created_at is our column
// (which survives a migration backfill; zitadel's org creation_date is the day
// the identity record was made and cannot be corrected).
//
// AGENT_DETAILS_V2_URL was the per-org detail fetch (getTenantDetails) until
// 2026-09-08; the drawer now reads `${AGENT_LIST_V3_URL}/{id}`
// (GetOrganizationV3, combird DB, ~20 ms) instead of the zitadel-backed v2
// call that cost ~2.1 s per click. Kept exported for the projects URL family.
export const AGENT_LIST_V3_URL = `${UI_API_URL_PATH_NEW}/api/v3/organizations`;
export const GET_TENANT_DETAILS = "GET_TENANT_DETAILS";
export const GET_TENANT_DETAILS_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{tenantId}`;
export const GET_TENANT_USERS = "GET_TENANT_USERS";
export const GET_TENANT_USERS_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{tenantId}/users`;
export const GET_TENANT_SMS_CONFIG = "GET_TENANT_SMS_CONFIG";

// ── Balance notifications + burn-down ────────────────────────────────────
// The list feeds the table (all orgs in ONE call, sorted most-urgent-first by
// the server). balance-usage is the per-org drill-down behind the row click —
// it is the only source of a DAILY series, which the chart needs.
//
// ⚠️ balance-usage currently derives consumption from ClickHouse sms_messages
// (credits stamped on messages). It is a TEMPORARY source: once billing data
// lands in ClickHouse it moves there, and the response SHAPE stays the same.
export const ADMIN_BALANCE_NOTIFICATIONS = "ADMIN_BALANCE_NOTIFICATIONS";
export const ADMIN_BALANCE_NOTIFICATIONS_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/balance/notifications`;
export const ADMIN_BALANCE_USAGE_ALL = "ADMIN_BALANCE_USAGE_ALL";
export const ADMIN_BALANCE_USAGE_ALL_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/balance-usage`;
export const ADMIN_BALANCE_USAGE = "ADMIN_BALANCE_USAGE";
export const ADMIN_BALANCE_USAGE_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/customers/{orgId}/balance-usage`;
export const GET_TENANT_SMS_CONFIG_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{tenantId}/sms_config`;
export const ADD_BALANCE = "ADD_BALANCE";
//export const ADD_BALANCE_URL = `${ SMSAPI_URL_PATH }/api/smsBalance?instituteId=instId`;
export const ADD_BALANCE_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{instId}/balance`;
export const ADD_SMS_TYPE = "ADD_SMS_TYPE";
//export const ADD_SMS_TYPE_URL = `${ SMSAPI_URL_PATH }/api/smsBalance/smsType?instituteId=instId`;
export const ADD_SMS_TYPE_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{instId}/sms_types`;
export const CHANGE_STATUS = "CHANGE_STATUS";
// export const CHANGE_STATUS_URL = `${ SMSAPI_URL_PATH }/api/institute/accountstatus?instituteId=instId`;
export const CHANGE_STATUS_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{instId}/status`;
// Per-user IAM state — identity-layer (login on/off), distinct from the
// tenant-level account_status (billing). See docs/ADR_TENANT_STATUS_AND_TIER.md.
export const ACTIVATE_USER_URL   = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{tenantId}/users/{userId}/activate`;
export const DEACTIVATE_USER_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{tenantId}/users/{userId}/deactivate`;
// Per-user profile edit (name / email / phone). Zitadel write-through;
// changing email does NOT change the login username. See UpdateTenantUser.
export const UPDATE_TENANT_USER_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{tenantId}/users/{userId}`;
export const UPDATE_ORG_NAME_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/orgs/{orgId}/org_name`;
export const UPDATE_OPERATOR = "UPDATE_OPERATOR";
//export const UPDATE_OPERATOR_URL = `${ SMSAPI_URL_PATH }/api/institute/operatorAssigned?instituteId=instId`;
export const UPDATE_OPERATOR_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{instId}/operator`;
export const EDIT_DLT = "EDIT_DLT";
//export const EDIT_DLT_URL = `${ SMSAPI_URL_PATH }/api/institute/dltPrincipalEntityId?instituteId=instId`;
export const EDIT_DLT_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{instId}/dlt`;
// Welcome offer of one org (SS-13): PUT {enabled, extendDays 0..30}. Admin + support.
export const TENANT_OFFER_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{tenantId}/offer`;
// Per-tenant DLT TM chain override (TM-A,TM-D portion of TLV 0x1402).
// PUT body: { "dlt_tm_chain": "<TM-A>,<TM-D>" } — empty string clears.
export const ADD_SENDER_ID = "ADD_SENDER_ID";
// export const ADD_SENDER_ID_URL = `${ SMSAPI_URL_PATH }/api/institute/senderIds?instituteId=instId`;
export const ADD_SENDER_ID_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{instId}/sender_ids`;
// Per-header downstream DLT Telemarketer ID (TM-D). Replaces the retired
// tenant-level dlt_tm_chain override — the TM chain is now resolved per
// sender ID at submit time.
// PUT body: { "dlt_tmd_id": "<value>" } — empty string clears.
export const EDIT_SENDER_ID_DLT_TMD_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{instId}/sender_ids/{senderid}/dlt_tmd`;

// Read-only preview: the resolved TLV 0x1402 chain per sender header x SMS
// type, computed server-side by the same rule the sender uses. Powers the
// Routing → DLT TMD sub-tab.
export const DLT_CHAIN_PREVIEW_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{instId}/dlt_chain_preview`;

export const CHANGE_DEFAULT_SENDER_ID = "CHANGE_DEFAULT_SENDER_ID";
export const CHANGE_DEFAULT_SENDER_ID_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{instId}/default_sender_id`;

export const SET_DEFAULT_SMS_TYPE = "SET_DEFAULT_SMS_TYPE";
export const SET_DEFAULT_SMS_TYPE_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{instId}/default_sms_type`;

// Admin Template Management
export const ADMIN_LIST_TEMPLATES = "ADMIN_LIST_TEMPLATES";
export const ADMIN_LIST_TEMPLATES_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{tenantId}/templates`;
export const ADMIN_CREATE_TEMPLATE = "ADMIN_CREATE_TEMPLATE";
export const ADMIN_UPDATE_TEMPLATE = "ADMIN_UPDATE_TEMPLATE";
export const ADMIN_DELETE_TEMPLATE = "ADMIN_DELETE_TEMPLATE";


export const BULK_CONTACT = "BULK_CONTACT";
export const DELETE_BULK_CONTACT = "DELETE_BULK_CONTACT";
// Go ContactService bulk endpoints. Legacy: `${API_URL_PATH}/api/contact/bulk`
export const BULK_CONTACT_URL = `${UI_API_URL_PATH_NEW}/api/v1/contacts:bulk-create`;
export const BULK_DELETE_CONTACT_URL = `${UI_API_URL_PATH_NEW}/api/v1/contacts:bulk-delete`;
export const CONTACT_COUNT_URL = `${UI_API_URL_PATH_NEW}/api/v1/contacts:count`;

export const SCHEDULE_SMS_URL = `${SMSAPI_URL_PATH}/api/sms/schedule`;
export const GET_SCHEDULED_SMS = "GET_SCHEDULED_SMS";
export const RE_SCHEDULED_SMS = "RE_SCHEDULED_SMS";
export const CANCEL_SCHEDULED_SMS = "CANCEL_SCHEDULED_SMS";

export const SMS_DETAILS = "SMS_DETAILS";
export const SMS_DETAILS_URL = `${UI_API_URL_PATH_NEW}/api/v1/org/me/balance`;
// export const SMS_DETAILS_URL = `${ SMSAPI_URL_PATH }/api/smsBalance`;

export const GET_SMS_CONFIG_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/sms_config`;
// Self-service: add sender IDs / headers to the caller's own tenant.
// POST body: { senderIds: ["FOO", "BAR"] }. Tenant_id taken from auth context.
// DLT entity ID stays support-only; unregistered headers are rejected at submit.
export const ADD_MY_SENDER_ID = "ADD_MY_SENDER_ID";
export const ADD_MY_SENDER_ID_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/sms_config/sender_ids`;
// First-run setup for self-signup orgs (components/FirstRun).
export const MY_ONBOARDING_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/onboarding`;
// Notification center (notification-center-service): email templates,
// settings, sent emails, opt-outs. Platform admins (templates / settings) and
// support (sent emails / opt-outs).
export const NOTIFICATIONS_URL = `${UI_API_URL_PATH_NEW}/api/v1/notifications`;
// One org's sent emails (org in the path: per-org auth / rate-limit rules).
export const ADMIN_TENANT_NOTIFICATIONS_SEARCH_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/tenants/{tenantId}/notifications/search`;
export const FIRST_RUN_CHOICE_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/onboarding/first_run`;
// Shown to orgs without DLT registration. dltRegister*: the DLT operator we
// point self-registering customers to (SmartPing) and its fee / validity.
// demoVideoUrl is the first-run footer link (hidden while empty). tmId /
// tmName: our DLT telemarketer, which the customer's PE-TM chain request
// must name.
export const FIRST_RUN_SUPPORT = {
  email: 'support@combirds.com',
  phone: '8962257590',
  dltRegisterUrl: 'https://smartping.live/entity/signup/Indian',
  dltRegisterFee: '₹5,900',
  dltValidity: '2 years',
  demoVideoUrl: 'https://youtu.be/FxqVMNozTWg',
  tmId: '1702167670776712706',
  tmName: 'Edumarc Technologies Private Limited'
};

// SmsConfigMeService — self-serve update/delete/set-default on the caller's
// own sender IDs. Tenant_id from auth context, admin role gate matches
// AddMySenderIds. Edit/delete/set-default need only the sender_id row id;
// remaining fields are pre-filled from the existing record in /me/sms_config.
export const UPDATE_MY_SENDER_ID = "UPDATE_MY_SENDER_ID";
export const DELETE_MY_SENDER_ID = "DELETE_MY_SENDER_ID";
export const SET_MY_DEFAULT_SENDER_ID = "SET_MY_DEFAULT_SENDER_ID";
export const SENDER_ID_BY_ID_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/sms_config/sender_ids/{id}`;
export const SENDER_ID_DEFAULT_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/sms_config/sender_ids/{id}/default`;

export const DASHBOARD_DETAILS = "DASHBOARD_DETAILS";
export const DASHBOARD_DETAILS_URL = ""; //`${ SMSAPI_URL_PATH }/api/dashboard/v2`;

//export const CHANGE_PASSWORD_URL = `${ API_URL_PATH }/api/auth/c/update`;
export const CHANGE_PASSWORD_URL = `${UI_API_URL_PATH_NEW}/api/v1/user/password`;
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";

export const ADD_BLOCK_NUMBER_URL = `${SMSAPI_URL_PATH}/api/blockednumbers`;
export const ADD_BLOCK_NUMBER = "ADD_BLOCK_NUMBER";
export const GET_BLOCK_NUMBER = "GET_BLOCK_NUMBER";
export const GET_OWNED_BLOCKED_CONTACT = "GET_OWNED_BLOCKED_CONTACT";
export const BLOCK_CONTACT = "BLOCK_CONTACT";
export const DELETE_BLOCK_CONTACT = "DELETE_BLOCK_CONTACT";
// export const BLOCKED_CONTACT_URL = `${ SMSAPI_URL_PATH }/api/blockednumbers`;
// New combird BlockedNumberService (OIDC-authed, tenant taken from the token —
// no org id in the URL). One path, GET/POST/DELETE. Replaces the legacy edugo
// `/reader/v1/.../org/me/block_number`.
export const OWN_BLOCKED_CONTACT_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/blockednumbers`;
// export const ALL_BLOCKED_CONTACT_URL = `${ UI_API_URL_PATH }/api/v1/org/admin/block_number`;

export const DELETE_SENDER_ID_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/tenants/{instId}/sender_ids/{senderid}`;
// export const DELETE_SENDER_ID_URL = `${ SMSAPI_URL_PATH }/api/institute/senderIds`;
export const DELETE_SENDER_ID = "DELETE_SENDER_ID";

export const IMPERSONATE_USER = "IMPERSONATE_USER";
export const IMPERSONATE_USER_URL = `${UI_API_URL_PATH_NEW}/api/v1/support/impersonate`;

// Support-triggered account emails. Backend service is OnboardingAdminService
// (admin path) but the handler also accepts support role. Cooldown: 5 min per
// (tenant, user, template) — backend returns 429 while it is active.
// Welcome email is the only account email left after the OTP-only cutover
// (invite/reset-password/passkey-setup all retired). Success returns
// { audit_id, masked_recipient }.
export const SEND_WELCOME_EMAIL_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/tenants/{tenantId}/users/{userId}/welcome-email`;
// MANDATE v2 (OTP-only login): registers zitadel OTP auth methods so code
// login works. Replaces the retired reset-password + passkey-setup actions.
export const ENSURE_OTP_METHODS_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/tenants/{tenantId}/otp-methods/ensure`;
// User session management (zitadel session v2) — single-account rollout:
// list a user's IdP sessions / terminate one so stale multi-account logins
// die server-side too (the browser half is SessionIdentityGuard).
export const LIST_USER_SESSIONS_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/tenants/{tenantId}/users/{userId}/sessions`;
export const TERMINATE_USER_SESSION_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/tenants/{tenantId}/users/{userId}/sessions/{sessionId}`;
// Template
export const GET_TEMPLATE = "GET_TEMPLATE";
//export const GET_TEMPLATE_URL = `${ SMSAPI_URL_PATH }/api/template`;
export const GET_TEMPLATE_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/templates`;

export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
export const POST_TEMPLATE = "POST_TEMPLATE";
export const EDIT_TEMPLATE = "EDIT_TEMPLATE";

export const DASHBOARD_SMS_STATS = "DASHBOARD_SMS_STATS";
export const DASHBOARD_SMS_STATS_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/dashboard`;
export const GET_MY_CAMPAIGN_MESSAGE_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/campaigns/{campaign_id}/messages/{message_id}`;
// Resolve a single message by id WITHOUT a campaign_id (GetMyMessage). Use this
// for dashboard "last activity" lookups — lastActivitySent/Received are message
// ids whose campaign_id differs, so the campaign-scoped URL above 404s.
export const GET_MY_MESSAGE_URL = `${UI_API_URL_PATH_NEW}/api/v1/me/messages/{message_id}`;
export const CAMAIGN_DETAILS = `${UI_API_URL_PATH_NEW}/api/v1/me/campaigns/{campaign_id}`;

export const BRAND_LOGO_LINK = process.env.REACT_APP_BRAND_LOGO;

export const GET_CREDIT_HISTORY = "GET_CREDIT_HISTORY";
export const GET_CREDIT_HISTORY_URL = `${UI_API_URL_PATH_NEW}/api/v1/org/me/balance/credit_history`;
export const UI_API_CONTACT_US_URL_PATH = `${UI_API_URL_PATH}/api/v1/org/me/contact_us`;

// Billing API (multi-wallet via Go UI backend → Lago)
export const GET_MY_WALLETS = "GET_MY_WALLETS";
export const GET_MY_WALLETS_URL = `${UI_API_URL_PATH_NEW}/api/v1/billing/me/wallets`;
export const GET_MY_TRANSACTIONS = "GET_MY_TRANSACTIONS";
export const GET_MY_TRANSACTIONS_URL = `${UI_API_URL_PATH_NEW}/api/v1/billing/me/transactions`;
export const TOPUP_MY_WALLET = "TOPUP_MY_WALLET";
export const TOPUP_MY_WALLET_URL = `${UI_API_URL_PATH_NEW}/api/v1/billing/me/wallets/{lagoId}/topup`;
// Admin billing
export const ADMIN_GET_CUSTOMER_WALLETS = "ADMIN_GET_CUSTOMER_WALLETS";
export const ADMIN_GET_CUSTOMER_WALLETS_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/customers/{orgId}/wallets`;
export const ADMIN_GET_CUSTOMER_TRANSACTIONS =
  "ADMIN_GET_CUSTOMER_TRANSACTIONS";
export const ADMIN_GET_CUSTOMER_TRANSACTIONS_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/customers/{orgId}/transactions`;
export const ADMIN_CREATE_WALLETS = "ADMIN_CREATE_WALLETS";
export const ADMIN_CREATE_WALLETS_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/customers/{orgId}/wallets`;
export const ADMIN_CREATE_CUSTOM_WALLET = "ADMIN_CREATE_CUSTOM_WALLET";
export const ADMIN_CREATE_CUSTOM_WALLET_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/customers/{orgId}/wallets/custom`;
export const ADMIN_TOPUP_WALLET = "ADMIN_TOPUP_WALLET";
export const ADMIN_TOPUP_WALLET_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/customers/{orgId}/wallets/{lagoId}/topup`;
export const ADMIN_TERMINATE_WALLET = "ADMIN_TERMINATE_WALLET";
export const ADMIN_TERMINATE_WALLET_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/customers/{orgId}/wallets/{lagoId}/terminate`;
// Admin plans & subscriptions
export const ADMIN_LIST_PLANS = "ADMIN_LIST_PLANS";
export const ADMIN_LIST_PLANS_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/plans`;
export const ADMIN_CREATE_PLAN = "ADMIN_CREATE_PLAN";
export const ADMIN_CREATE_PLAN_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/plans`;
export const ADMIN_UPDATE_PLAN = "ADMIN_UPDATE_PLAN";
export const ADMIN_UPDATE_PLAN_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/plans/{planCode}`;
export const ADMIN_DELETE_PLAN = "ADMIN_DELETE_PLAN";
export const ADMIN_DELETE_PLAN_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/plans/{planCode}`;
export const ADMIN_CHANGE_SUBSCRIPTION = "ADMIN_CHANGE_SUBSCRIPTION";
export const ADMIN_CHANGE_SUBSCRIPTION_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/customers/{orgId}/subscription`;
export const ADMIN_GET_SUBSCRIPTION = "ADMIN_GET_SUBSCRIPTION";
export const ADMIN_GET_SUBSCRIPTION_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/customers/{orgId}/subscription`;
// Admin wallet edit & void
export const ADMIN_EDIT_WALLET = "ADMIN_EDIT_WALLET";
export const ADMIN_EDIT_WALLET_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/customers/{orgId}/wallets/{lagoId}`;
export const ADMIN_VOID_WALLET_CREDITS = "ADMIN_VOID_WALLET_CREDITS";
export const ADMIN_VOID_WALLET_CREDITS_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/customers/{orgId}/wallets/{lagoId}/void`;

// Admin billing setup (onboarding)
export const ADMIN_GET_BILLING_SETUP = "ADMIN_GET_BILLING_SETUP";
export const ADMIN_GET_BILLING_SETUP_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/customers/{orgId}/setup`;
export const ADMIN_RUN_BILLING_SETUP = "ADMIN_RUN_BILLING_SETUP";
export const ADMIN_RUN_BILLING_SETUP_URL = `${UI_API_URL_PATH_NEW}/api/v2/billing/admin/customers/{orgId}/setup`;
export const ADMIN_RUN_SMS_CONFIG_SETUP = "ADMIN_RUN_SMS_CONFIG_SETUP";
export const ADMIN_RUN_SMS_CONFIG_SETUP_URL = `${UI_API_URL_PATH_NEW}/api/v2/sms/admin/customers/{orgId}/setup`;
export const ADMIN_RUN_LIFECYCLE_SETUP = "ADMIN_RUN_LIFECYCLE_SETUP";
export const ADMIN_RUN_LIFECYCLE_SETUP_URL = `${UI_API_URL_PATH_NEW}/api/v2/lifecycle/admin/customers/{orgId}/setup`;

// Admin Onboarding (tenant provisioning)
export const ADMIN_CREATE_TENANT = "ADMIN_CREATE_TENANT";
export const ADMIN_CREATE_TENANT_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/tenants`;
// Standalone billing setup / reconfiguration (idempotent; per-SMS-type wallets)
export const ADMIN_SETUP_TENANT_BILLING = "ADMIN_SETUP_TENANT_BILLING";
export const ADMIN_SETUP_TENANT_BILLING_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/tenants/{tenantId}/billing/setup`;

// Lazy per-org project listing — TenantV2Service.GetOrganizationProjectSummary.
// One Zitadel ListProjects call; fired only when the operator opens the
// Projects tab so ListOrganizationsV2 stays cheap.
export const LIST_ORG_PROJECTS_URL = `${UI_API_URL_PATH_NEW}/api/v2/organizations/{orgId}/projects`;

export const RESUME_ONBOARDING = "RESUME_ONBOARDING";
export const RESUME_ONBOARDING_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/onboarding/{onboardingId}/resume`;
export const GET_ONBOARDING_STATUS = "GET_ONBOARDING_STATUS";
export const GET_ONBOARDING_STATUS_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/onboarding/{onboardingId}`;
export const LIST_ONBOARDINGS = "LIST_ONBOARDINGS";
export const LIST_ONBOARDINGS_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/onboarding`;
export const GET_ONBOARDING_CONFIG = "GET_ONBOARDING_CONFIG";
export const GET_ONBOARDING_CONFIG_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/onboarding_config/{workspaceType}`;
export const UPDATE_ONBOARDING_CONFIG = "UPDATE_ONBOARDING_CONFIG";
export const UPDATE_ONBOARDING_CONFIG_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/onboarding_config/{workspaceType}`;

// Admin API Keys (machine user / PAT) — see OnboardingAdminService in
// combird/api/services/ui/v1/onboarding_admin.proto. PROVISION creates or
// rotates a machine-user-backed key for one (tenant, project); LIST
// returns the key set visible to the support panel for that tenant.
// Customer-facing /api/v1/apikeys endpoints are auth-context-scoped and
// can't read another tenant's keys — these admin endpoints fill that gap.
export const ADMIN_LIST_API_KEYS_BY_TENANT = "ADMIN_LIST_API_KEYS_BY_TENANT";
export const ADMIN_LIST_API_KEYS_BY_TENANT_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/tenants/{tenantId}/api_keys`;
export const ADMIN_PROVISION_MACHINE_USER_API_KEY = "ADMIN_PROVISION_MACHINE_USER_API_KEY";
export const ADMIN_PROVISION_MACHINE_USER_API_KEY_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/tenants/{tenantId}/api_keys/provision`;
export const ADMIN_REVOKE_API_KEY = "ADMIN_REVOKE_API_KEY";
export const ADMIN_REVOKE_API_KEY_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/tenants/{tenantId}/api_keys/{id}/revoke`;

// Admin reverse lookups (/api/v1/admin/search/*) — "which org does this X
// belong to?". POST because the search term can be a secret (an API key
// must never land in a URL / access log). Future search types (phone
// number, message id, ...) add one URL each under the same path family.
export const ADMIN_SEARCH_API_KEY_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/search/api_key`;
// Identity search — zitadel directly, by current email / phone / org id.
// POST for the same reason as the api-key search: an email or phone in a URL
// ends up in access logs.
export const ADMIN_SEARCH_IDENTITY_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/search/identity`;

// Lifecycle API (account status, subscriptions, entitlements, audit trail)
export const GET_ACCOUNT_STATUS = "GET_ACCOUNT_STATUS";
export const GET_ACCOUNT_STATUS_URL = `${UI_API_URL_PATH_NEW}/api/v2/lifecycle/admin/accounts/{orgId}`;
export const TRANSITION_ACCOUNT = "TRANSITION_ACCOUNT";
export const TRANSITION_ACCOUNT_URL = `${UI_API_URL_PATH_NEW}/api/v2/lifecycle/admin/accounts/{orgId}/transition`;
export const GET_STATUS_HISTORY = "GET_STATUS_HISTORY";
export const GET_STATUS_HISTORY_URL = `${UI_API_URL_PATH_NEW}/api/v2/lifecycle/admin/accounts/{orgId}/history`;
export const GET_ACCOUNT_SUBSCRIPTIONS = "GET_ACCOUNT_SUBSCRIPTIONS";
export const GET_ACCOUNT_SUBSCRIPTIONS_URL = `${UI_API_URL_PATH_NEW}/api/v2/lifecycle/admin/accounts/{orgId}/subscriptions`;
export const GET_ACCOUNT_ENTITLEMENTS = "GET_ACCOUNT_ENTITLEMENTS";
export const GET_ACCOUNT_ENTITLEMENTS_URL = `${UI_API_URL_PATH_NEW}/api/v2/lifecycle/admin/accounts/{orgId}/entitlements`;
export const LIST_LIFECYCLE_PLANS = "LIST_LIFECYCLE_PLANS";
export const LIST_LIFECYCLE_PLANS_URL = `${UI_API_URL_PATH_NEW}/api/v2/lifecycle/admin/plans`;

// Operator Manager
export const LIST_OPERATORS = "LIST_OPERATORS";
export const LIST_OPERATORS_URL = `${UI_API_URL_PATH_NEW}/api/v1/operators`;
export const CREATE_OPERATOR = "CREATE_OPERATOR";
export const CREATE_OPERATOR_URL = `${UI_API_URL_PATH_NEW}/api/v1/operators`;
export const UPDATE_OPERATOR_MGR = "UPDATE_OPERATOR_MGR";
export const UPDATE_OPERATOR_MGR_URL = `${UI_API_URL_PATH_NEW}/api/v1/operators/{operatorId}`;
export const STOP_OPERATOR = "STOP_OPERATOR";
export const STOP_OPERATOR_URL = `${UI_API_URL_PATH_NEW}/api/v1/operators/{smscId}/stop`;
export const START_OPERATOR = "START_OPERATOR";
export const START_OPERATOR_URL = `${UI_API_URL_PATH_NEW}/api/v1/operators/{smscId}/start`;
export const RESTART_OPERATOR = "RESTART_OPERATOR";
export const RESTART_OPERATOR_URL = `${UI_API_URL_PATH_NEW}/api/v1/operators/{smscId}/restart`;
export const GET_KANNEL_STATUS = "GET_KANNEL_STATUS";
export const GET_KANNEL_STATUS_URL = `${UI_API_URL_PATH_NEW}/api/v1/operators/kannel_status`;
export const LIST_OPERATOR_HEALTH = "LIST_OPERATOR_HEALTH";
export const LIST_OPERATOR_HEALTH_URL = `${UI_API_URL_PATH_NEW}/api/v1/operators/health`;
export const GET_ROUTE_CHAIN = "GET_ROUTE_CHAIN";
export const GET_ROUTE_CHAIN_URL = `${UI_API_URL_PATH_NEW}/api/v1/operators/routes`;
export const SET_OPERATOR_ROUTE = "SET_OPERATOR_ROUTE";
export const SET_OPERATOR_ROUTE_URL = `${UI_API_URL_PATH_NEW}/api/v1/operators/routes`;
export const REMOVE_OPERATOR_ROUTE = "REMOVE_OPERATOR_ROUTE";
export const REMOVE_OPERATOR_ROUTE_URL = `${UI_API_URL_PATH_NEW}/api/v1/operators/routes/{routeId}`;
export const BULK_SET_OPERATOR_ROUTE = "BULK_SET_OPERATOR_ROUTE";
export const BULK_SET_OPERATOR_ROUTE_URL = `${UI_API_URL_PATH_NEW}/api/v1/operators/routes/bulk`;
export const GET_GLOBAL_ROUTING_CONFIG = "GET_GLOBAL_ROUTING_CONFIG";
export const GET_GLOBAL_ROUTING_CONFIG_URL = `${UI_API_URL_PATH_NEW}/api/v1/operators/routing/global`;
export const UPDATE_GLOBAL_ROUTE = "UPDATE_GLOBAL_ROUTE";
export const UPDATE_GLOBAL_ROUTE_URL = `${UI_API_URL_PATH_NEW}/api/v1/operators/routing/global`;
export const ENABLE_FORCE_GLOBAL = "ENABLE_FORCE_GLOBAL";
export const ENABLE_FORCE_GLOBAL_URL = `${UI_API_URL_PATH_NEW}/api/v1/operators/routing/global/enable`;
export const DISABLE_FORCE_GLOBAL = "DISABLE_FORCE_GLOBAL";
export const DISABLE_FORCE_GLOBAL_URL = `${UI_API_URL_PATH_NEW}/api/v1/operators/routing/global/disable`;
export const LIST_TENANT_ROUTES = "LIST_TENANT_ROUTES";
export const LIST_TENANT_ROUTES_URL = `${UI_API_URL_PATH_NEW}/api/v1/operators/routing/tenants`;

// Kannel Box Settings Manager
export const LIST_KANNEL_BOXES = "LIST_KANNEL_BOXES";
export const LIST_KANNEL_BOXES_URL = `${UI_API_URL_PATH_NEW}/api/v1/kannel/boxes`;
export const UPSERT_KANNEL_BOX = "UPSERT_KANNEL_BOX";
export const UPSERT_KANNEL_BOX_URL = `${UI_API_URL_PATH_NEW}/api/v1/kannel/boxes/{boxId}`;
export const LIST_BOX_OPERATORS = "LIST_BOX_OPERATORS";
export const LIST_BOX_OPERATORS_URL = `${UI_API_URL_PATH_NEW}/api/v1/kannel/boxes/{boxId}/operators`;
export const SET_BOX_OPERATORS = "SET_BOX_OPERATORS";
export const SET_BOX_OPERATORS_URL = `${UI_API_URL_PATH_NEW}/api/v1/kannel/boxes/{boxId}/operators`;
export const LIST_BOX_SMSBOXES = "LIST_BOX_SMSBOXES";
export const LIST_BOX_SMSBOXES_URL = `${UI_API_URL_PATH_NEW}/api/v1/kannel/boxes/{boxId}/smsboxes`;
export const SET_BOX_SMSBOXES = "SET_BOX_SMSBOXES";
export const SET_BOX_SMSBOXES_URL = `${UI_API_URL_PATH_NEW}/api/v1/kannel/boxes/{boxId}/smsboxes`;

// Ops Admin Dashboard (OpsAdminService — admin/support, roles [admin, platform_admin])
// Reads pre-aggregated ClickHouse `dashboard_metrics` where view_type='ops'.
// Source-of-truth proto: common/rpc/proto/combird/api/services/ui/v1/ops_admin.proto
// Handler: control_plane/platform/inputports/ui_api/ops_admin_handler.go
// Server caps dashboard responses at 5000 rows. bucket_type is REQUIRED
// (one of hour|day|month). Latency fields are AVERAGES (sum_ms/count), not
// percentiles — p50/p99 deferred (Tier 3).
export const ADMIN_GET_OPS_DASHBOARD = "ADMIN_GET_OPS_DASHBOARD";
export const ADMIN_GET_OPS_DASHBOARD_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/dashboard/ops`;
export const ADMIN_GET_STUCK_QUEUE_AGGREGATE = "ADMIN_GET_STUCK_QUEUE_AGGREGATE";
export const ADMIN_GET_STUCK_QUEUE_AGGREGATE_URL = `${UI_API_URL_PATH_NEW}/api/v1/admin/dashboard/stuck_queue`;

// Rate-limit configuration (RateLimitConfigService — admin/support)
// Source-of-truth doc: combird_apps/core_apps/apps/rlqs/RLQS_TENANT_TIER_PLAN.md
//
// Policy templates
export const LIST_RATE_LIMIT_POLICIES = "LIST_RATE_LIMIT_POLICIES";
export const LIST_RATE_LIMIT_POLICIES_URL = `${UI_API_URL_PATH_NEW}/api/v1/rate-limits/policies`;
export const CREATE_RATE_LIMIT_POLICY = "CREATE_RATE_LIMIT_POLICY";
export const CREATE_RATE_LIMIT_POLICY_URL = `${UI_API_URL_PATH_NEW}/api/v1/rate-limits/policies`;
export const UPDATE_RATE_LIMIT_POLICY = "UPDATE_RATE_LIMIT_POLICY";
export const UPDATE_RATE_LIMIT_POLICY_URL = `${UI_API_URL_PATH_NEW}/api/v1/rate-limits/policies/{name}`;
export const DELETE_RATE_LIMIT_POLICY = "DELETE_RATE_LIMIT_POLICY";
export const DELETE_RATE_LIMIT_POLICY_URL = `${UI_API_URL_PATH_NEW}/api/v1/rate-limits/policies/{name}`;
// Per-tenant tier
export const LIST_TENANT_RATE_LIMITS = "LIST_TENANT_RATE_LIMITS";
export const LIST_TENANT_RATE_LIMITS_URL = `${UI_API_URL_PATH_NEW}/api/v1/rate-limits/tenants`;
export const GET_TENANT_RATE_LIMIT = "GET_TENANT_RATE_LIMIT";
export const GET_TENANT_RATE_LIMIT_URL = `${UI_API_URL_PATH_NEW}/api/v1/rate-limits/tenants/{tenantId}`;
export const SET_TENANT_TIER = "SET_TENANT_TIER";
export const SET_TENANT_TIER_URL = `${UI_API_URL_PATH_NEW}/api/v1/rate-limits/tenants/{tenantId}/tier`;
// Per-tenant overrides
export const SET_TENANT_OVERRIDE = "SET_TENANT_OVERRIDE";
export const SET_TENANT_OVERRIDE_URL = `${UI_API_URL_PATH_NEW}/api/v1/rate-limits/tenants/{tenantId}/overrides`;
export const REMOVE_TENANT_OVERRIDE = "REMOVE_TENANT_OVERRIDE";
export const REMOVE_TENANT_OVERRIDE_URL = `${UI_API_URL_PATH_NEW}/api/v1/rate-limits/tenants/{tenantId}/overrides/{scope}`;

// Send-SMS maintenance gate (2026-09-06). While true, the Send buttons on
// Send SMS (send + schedule) and Customize SMS show this text instead of
// submitting. Flip to false to restore sending; nothing else changes.
export const SEND_SMS_MAINTENANCE = false; // 2026-09-07: maintenance over, sending restored
export const SEND_SMS_MAINTENANCE_MSG =
  "Please try later, we are under maintenance. We will resume services shortly.";
// Snackbar styling for the maintenance message — red so it reads as a stop,
// not as the grey "SMS submitted" confirmation people are used to.
export const SEND_SMS_MAINTENANCE_SNACK_PROPS = {
  sx: { bgcolor: "#d32f2f", color: "#fff", fontWeight: 500, fontSize: 15 },
};
